// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"f0a8a920","977":"8d6a7445"}[chunkId] + ".chunk.js";
};